require('core-js/es/map');

import './array-forEach';
import './array-from';
import './element-closest';
import './element-matches';
import './nodelist-forEach';
import './object-assign';

import 'whatwg-fetch';
